import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API } from '../context/AuthContext';
import axios from "axios";

export default function Register() {
  const [form, setForm] = useState({ first_name: '', last_name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleUpgradeRedirect = async () => {
    try {
      const token = localStorage.getItem("token");
      const params = new URLSearchParams(window.location.search);
      const billing = params.get('billing') || 'monthly';
      const res = await axios.post(`${API}/api/stripe/create-checkout`, { tier: "premium", billing }, { headers: { Authorization: `Bearer ${token}` } });
      window.location.href = res.data.url;
    } catch (err) {
      console.error("Checkout error:", err);
      navigate("/onboarding");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    try {
      await register(form.email, form.password, form.first_name, form.last_name);
      await handleUpgradeRedirect();
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <a href="/" style={styles.logo}>CryptoFolio <span style={styles.logoAccent}>CFO</span></a>
        <h1 style={styles.title}>Create your account</h1>
        <p style={styles.sub}>Start planning your XRP exit strategy today</p>
        <a href={`${API}/api/auth/google`} style={styles.googleBtn}>
          <svg width="18" height="18" viewBox="0 0 24 24" style={{marginRight:'10px'}}>
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Sign up with Google
        </a>
        <div style={styles.divider}><span style={styles.dividerText}>or sign up with email</span></div>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>First name</label>
              <input type="text" name="first_name" value={form.first_name} onChange={handleChange} style={styles.input} placeholder="John" required />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Last name</label>
              <input type="text" name="last_name" value={form.last_name} onChange={handleChange} style={styles.input} placeholder="Doe" required />
            </div>
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} style={styles.input} placeholder="you@example.com" required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input type="password" name="password" value={form.password} onChange={handleChange} style={styles.input} placeholder="Min. 8 characters" required />
          </div>
          <button type="submit" style={styles.btn} disabled={loading}>
            {loading ? 'Creating account...' : 'Create free account'}
          </button>
        </form>
        <p style={styles.disclaimer}>
          By creating an account you agree this tool provides estimates only and is not financial or tax advice.
        </p>
        <p style={styles.footer}>
          Already have an account? <Link to="/login" style={styles.link}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f4f1eb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', fontFamily: 'system-ui, sans-serif' },
  card: { background: '#fff', borderRadius: '16px', padding: '2.5rem', width: '100%', maxWidth: '460px', border: '1px solid rgba(0,0,0,0.08)' },
  logo: { fontFamily: 'Georgia, serif', fontSize: '18px', color: '#1a1a1a', textDecoration: 'none', display: 'block', marginBottom: '2rem' },
  logoAccent: { color: '#1a6b4a' },
  title: { fontSize: '24px', fontWeight: '500', color: '#1a1a1a', marginBottom: '0.5rem' },
  sub: { fontSize: '14px', color: '#6b6b6b', marginBottom: '1.5rem' },
  error: { background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', padding: '10px 14px', borderRadius: '8px', fontSize: '14px', marginBottom: '1rem' },
  googleBtn: { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', padding: '11px', border: '1px solid rgba(0,0,0,0.12)', borderRadius: '8px', fontSize: '15px', color: '#1a1a1a', textDecoration: 'none', boxSizing: 'border-box', marginBottom: '1rem', background: '#fff' },
  divider: { display: 'flex', alignItems: 'center', margin: '1rem 0', gap: '12px' },
  dividerText: { fontSize: '12px', color: '#9b9b9b', whiteSpace: 'nowrap', background: '#fff', padding: '0 8px' },
  row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  field: { marginBottom: '1rem' },
  label: { display: 'block', fontSize: '13px', fontWeight: '500', color: '#6b6b6b', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' },
  input: { width: '100%', padding: '10px 14px', border: '1px solid rgba(0,0,0,0.12)', borderRadius: '8px', fontSize: '15px', color: '#1a1a1a', outline: 'none', boxSizing: 'border-box', fontFamily: 'system-ui, sans-serif' },
  btn: { width: '100%', padding: '12px', background: '#1a6b4a', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', marginTop: '0.5rem' },
  disclaimer: { fontSize: '11px', color: '#9b9b9b', textAlign: 'center', marginTop: '1rem', lineHeight: '1.5' },
  footer: { textAlign: 'center', fontSize: '13px', color: '#6b6b6b', marginTop: '1rem' },
  link: { color: '#1a6b4a', textDecoration: 'none', fontWeight: '500' }
};
